import { getElementDeserializer, setDefaults } from '@udecode/slate-plugins';
import divElement from './element';

const deserializeDiv = options => {
  const { div } = setDefaults(options, divElement);

  return {
    element: getElementDeserializer({
      type: div.type,
      rules: [{ nodeNames: 'DIV' }],
    }),
  };
};

export default deserializeDiv;
